import { useContext } from 'react';
import { EditorContext } from '@/infras/brick-editor/EditorContext';

export function useEditorContext() {
  return useContext(EditorContext);
}
